import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onChange", "rules", "id", "control", "hasLeftPadding", "borderless", "twStyle", "inputStyle", "wrapperStyle", "testId", "isError", "supportText", "supportTextStyles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import * as React from 'react';
import { useCallback } from 'react';
import { Controller } from 'react-hook-form';
import { TextInput as FlowBiteTextInput } from 'flowbite-react';
import { borderColorObject } from './form.types';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TextInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var onChange = props.onChange,
      _props$rules = props.rules,
      rules = _props$rules === void 0 ? {} : _props$rules,
      id = props.id,
      control = props.control,
      _props$hasLeftPadding = props.hasLeftPadding,
      hasLeftPadding = _props$hasLeftPadding === void 0 ? false : _props$hasLeftPadding,
      borderless = props.borderless,
      twStyle = props.twStyle,
      inputStyle = props.inputStyle,
      wrapperStyle = props.wrapperStyle,
      testId = props.testId,
      isError = props.isError,
      supportText = props.supportText,
      supportTextStyles = props.supportTextStyles,
      rest = _objectWithoutProperties(props, _excluded);

  var handleChange = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (onChange) onChange(e.target.value);
    return e;
  }, [onChange]);
  var supportTextEl = React.useMemo(function () {
    return supportText ? /*#__PURE__*/_jsx(StyledSupportText, {
      $isError: isError,
      supportTextStyles: supportTextStyles,
      children: supportText
    }) : null;
  }, [isError, supportText, supportTextStyles]);
  if (control) return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Controller, {
      name: id,
      control: control,
      rules: rules,
      render: function render(_ref) {
        var field = _ref.field;
        return /*#__PURE__*/_jsx(TextInputStyled, _objectSpread(_objectSpread(_objectSpread({
          hasleftpadding: hasLeftPadding ? '1' : '0',
          borderless: borderless ? '1' : '0',
          twstyle: twStyle,
          wrapperstyle: wrapperStyle,
          inputstyle: inputStyle,
          "data-cy": testId,
          $isError: isError
        }, field), rest), {}, {
          ref: ref
        }));
      }
    }), supportTextEl]
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TextInputStyled, _objectSpread(_objectSpread({
      onChange: handleChange,
      hasleftpadding: hasLeftPadding ? '1' : '0',
      borderless: borderless ? '1' : '0',
      twstyle: twStyle,
      wrapperstyle: wrapperStyle,
      inputstyle: inputStyle,
      "data-cy": testId,
      $isError: isError
    }, rest), {}, {
      ref: ref
    })), supportTextEl]
  });
});
export default TextInput;

var TextInputStyled = /*#__PURE__*/_styled(FlowBiteTextInput).withConfig({
  displayName: "forminput__TextInputStyled",
  componentId: "sc-11izlex-0"
})(["", " svg{", "}input{", " ", " ", " ", " ", " ", " ", " ", "}", " ", ""], {
  "paddingLeft": "0.25rem",
  "paddingRight": "0.25rem"
}, function (_ref2) {
  var rightIcon = _ref2.rightIcon,
      color = _ref2.color;
  return rightIcon && color === 'failure' ? {
    "--tw-text-opacity": "1",
    "color": "rgb(204 0 34 / var(--tw-text-opacity))"
  } : {};
}, {
  "borderRadius": "0.5rem",
  "borderWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(212 193 245 / var(--tw-border-opacity))",
  "padding": "0.75rem",
  "::placeholder": {
    "overflow": "hidden",
    "textOverflow": "ellipsis",
    "whiteSpace": "nowrap",
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "400",
    "--tw-text-opacity": "1 !important",
    "color": "rgb(156 163 175 / var(--tw-text-opacity)) !important"
  },
  ":focus": {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(196 177 231 / var(--tw-border-opacity))",
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(196 177 231 / var(--tw-ring-opacity))"
  }
}, function (_ref3) {
  var color = _ref3.color;
  return color === 'failure' ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(204 0 34 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity))"
  } : {};
}, function (_ref4) {
  var borderless = _ref4.borderless;
  return borderless === '1' ? {
    "borderWidth": "0px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    ":focus-visible": {
      "borderWidth": "0px",
      "outlineWidth": "0px",
      "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
      "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
      "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
    }
  } : {};
}, function (_ref5) {
  var _ref5$bordercolor = _ref5.bordercolor,
      bordercolor = _ref5$bordercolor === void 0 ? 'primary' : _ref5$bordercolor;
  return borderColorObject[bordercolor];
}, function (_ref6) {
  var hasleftpadding = _ref6.hasleftpadding;
  return hasleftpadding === '1' ? {
    "paddingLeft": "2.5rem"
  } : {};
}, function (_ref7) {
  var rightIcon = _ref7.rightIcon;
  return rightIcon ? {
    "paddingRight": "2.5rem"
  } : {};
}, function (_ref8) {
  var $isError = _ref8.$isError;
  return $isError ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(204 0 34 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1 !important",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity)) !important",
    "--tw-text-opacity": "1",
    "color": "rgb(145 0 24 / var(--tw-text-opacity))",
    "::placeholder": {
      "--tw-text-opacity": "1 !important",
      "color": "rgb(145 0 24 / var(--tw-text-opacity)) !important"
    }
  } : {};
}, function (_ref9) {
  var inputstyle = _ref9.inputstyle;
  return inputstyle;
}, function (_ref10) {
  var wrapperstyle = _ref10.wrapperstyle;
  return wrapperstyle;
}, function (_ref11) {
  var twstyle = _ref11.twstyle;
  return twstyle;
});

var StyledSupportText = /*#__PURE__*/_styled.p.withConfig({
  displayName: "forminput__StyledSupportText",
  componentId: "sc-11izlex-1"
})(function (_ref12) {
  var supportTextStyles = _ref12.supportTextStyles,
      $isError = _ref12.$isError;
  return [{
    "marginTop": "0.75rem",
    "fontSize": "0.875rem",
    "lineHeight": "1.313rem",
    "fontWeight": "400",
    "--tw-text-opacity": "1",
    "color": "rgb(107 114 128 / var(--tw-text-opacity))"
  }, $isError ? {
    "--tw-text-opacity": "1",
    "color": "rgb(186 0 31 / var(--tw-text-opacity))"
  } : {}].concat(_toConsumableArray(supportTextStyles || []));
});